/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/layer-1214322': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M2.5 8.86l9 5.2a1 1 0 001 0l9-5.2A1 1 0 0022 8a1 1 0 00-.5-.87l-9-5.19a1 1 0 00-1 0l-9 5.19A1 1 0 002 8a1 1 0 00.5.86zM12 4l7 4-7 4-7-4zm8.5 7.17L12 16l-8.5-4.87a1 1 0 00-1.37.37 1 1 0 00.37 1.36l9 5.2a1 1 0 001 0l9-5.2a1 1 0 00.37-1.36 1 1 0 00-1.37-.37zm0 4L12 20l-8.5-4.87a1 1 0 00-1.37.37 1 1 0 00.37 1.36l9 5.2a1 1 0 001 0l9-5.2a1 1 0 00.37-1.36 1 1 0 00-1.37-.37z"/>'
  }
})
